import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../SportsTravel/SportsMidBanner/SportsMidBanner.css";
import "./UniversityMidBanner.css";

const UniversityMidBanner = () => {
  return (
    <>
      <div className="container sports-mid-section">
        <div className="row px-md-4">
          <div className="col-md-12">
            <h1 className="headings">
              <span>Unforgettable </span>College Journeys Await
            </h1>
            <p className="grotesk-headings sports-mid-banner-p">
              At Blueberry Travel, we transform ordinary trips into
              extraordinary college travel adventures. Our specially crafted
              experiences are perfect for students seeking unique,
              cost-effective journeys. Whether it's a budget-friendly
              backpacking trip or a luxurious cultural diversity, we've got the
              ideal vacation plan just for you. Explore new destinations, have
              fun with friends, and make memories that will last a lifetime.
            </p>
            <p className="grotesk-headings sports-mid-banner-p">
              Join a vibrant network of like-minded college adventurers ready to
              explore the world. Our dedication to safety and support means you
              can travel worry-free. Meanwhile, our flexible itineraries and
              budget-friendly options make global exploration accessible.
            </p>
            <p className="sports-mid-banner-p">
              Start planning your epic journey with Blueberry Travel today.
              Let's create an extraordinary college experience together—your
              adventure begins here!
            </p>
          </div>
        </div>
      </div>

      <div className="uni-last-banner">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 text-white">
              <h1 className="headings">
                <span className="last-banner-span">Ready</span> to Escape the
                Textbooks and Explore the World{" "}
                <span className="text-white" style={{ fontWeight: "bold" }}>
                  ?{" "}
                </span>
              </h1>
              {/* <p>Contact Blueberry Travels Today</p> */}
              <div className="carouselCaption">
                <a href="/contact">
                  <button className="btn bg-transparent text-white mt-md-3 grotesk-headings fw-bold">
                    Contact Us
                  </button>
                </a>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="uni-banner-img d-md-block d-none">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/universitymidbanner.png"
                  alt="Travel Banner"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UniversityMidBanner;
